import {computed} from 'vue';
import {useStore} from 'vuex';
import {FileExportPayload} from '@/store/modules/files';

export function useExports() {
    const store = useStore();

    const newExportsCompleted = computed(() => store.getters['files/newExportsCompleted']);

    const getCompanyExports = () => {
        return store.dispatch('files/getCompanyExports');
    };

    const deleteCompanyExport = (exportId: string) => {
        return store.dispatch('files/deleteCompanyExport', exportId);
    };

    const setNewExportsCompleted = (payload: any) => {
        return store.commit('files/SET_NEW_EXPORTS_COMPLETED', payload);
    }

    const commitExport = async (payload: FileExportPayload) => {
        return await store.dispatch('files/commitExport', payload);
    }


    return {
        newExportsCompleted,
        getCompanyExports,
        setNewExportsCompleted,
        commitExport,
        deleteCompanyExport,
    };
} 